import { render } from "./ConfidantPageBar.vue?vue&type=template&id=85de43c0"
import script from "./ConfidantPageBar.vue?vue&type=script&lang=js"
export * from "./ConfidantPageBar.vue?vue&type=script&lang=js"

import "./ConfidantPageBar.vue?vue&type=style&index=0&id=85de43c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__